import { render, staticRenderFns } from "./UserCenterNav.vue?vue&type=template&id=1a37f187&scoped=true"
import script from "./UserCenterNav.vue?vue&type=script&lang=js"
export * from "./UserCenterNav.vue?vue&type=script&lang=js"
import style0 from "./UserCenterNav.vue?vue&type=style&index=0&id=1a37f187&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a37f187",
  null
  
)

export default component.exports